export default __webpack_public_path__ + "static/media/success-tick.9f3cabb2.svg";